import { Component, h } from '@stencil/core'

@Component({
  tag: 'search-button',
  styleUrl: 'search-button.scss',
})
export class SearchButton {
  render() {
    return (
      <div class="c11n-search__form__submit">
        <button
          type="button"
          aria-label="Search"
          class="c11n-button c11n-button--medium c11n-button--icon-primary c11n--on-light"
        >
          <span class="c11n-button__box">
            <span class="c11n-button__icon-only">
              <svg fill="#ffffff" height={14} width={14}>
                <path
                  d="M13.7265333,13.7265333 C14.0908898,13.3620668 14.0908898,12.7712665 13.7265333,12.4068 L11.2336,9.91386667 C11.1540898,9.83623848 11.1400548,9.71343261 11.2,9.61986667 C12.7859562,7.21942761 12.2968024,4.00803252 10.0680889,2.18863689 C7.83937529,0.369241252 4.59506283,0.532845819 2.56068766,2.56722099 C0.526312486,4.60159616 0.362707918,7.84590863 2.18210355,10.0746222 C4.00149919,12.3033358 7.21289428,12.7924895 9.61333333,11.2065333 C9.70604473,11.1456273 9.82876411,11.158094 9.90733333,11.2364 L12.4002667,13.7293333 C12.575925,13.9059433 12.8148922,14.0050094 13.0639838,14.0044856 C13.3130755,14.0039576 13.5516222,13.9038834 13.7265333,13.7265333 Z M2.8,6.53333333 C2.8,4.47147027 4.47147027,2.8 6.53333333,2.8 C8.5951964,2.8 10.2666667,4.47147027 10.2666667,6.53333333 C10.2666667,8.5951964 8.5951964,10.2666667 6.53333333,10.2666667 C5.54319177,10.2666667 4.59360383,9.87333446 3.89346802,9.17319865 C3.1933322,8.47306284 2.8,7.5234749 2.8,6.53333333 Z"
                >
                </path>
              </svg>
            </span>
          </span>
        </button>
      </div>
    )
  }
}
